<script>
  import { I18n } from "i18n-js"
  import i18n_translations from "../../../javascript/locales.json"
  import { LANDING_PAGE_TO_EXTENSION } from '../../../javascript/constants/landing_pages'

  // Import file type icons
  import docxIcon from '../../../javascript/images/modules/translations/index/docx.webp'
  import docxIcon2x from '../../../javascript/images/modules/translations/index/docx@2x.webp'
  import xlsxIcon from '../../../javascript/images/modules/translations/index/xlsx.webp'
  import xlsxIcon2x from '../../../javascript/images/modules/translations/index/xlsx@2x.webp'
  import pptxIcon from '../../../javascript/images/modules/translations/index/pptx.webp'
  import pptxIcon2x from '../../../javascript/images/modules/translations/index/pptx@2x.webp'
  import keyIcon from '../../../javascript/images/modules/translations/index/key.webp'
  import keyIcon2x from '../../../javascript/images/modules/translations/index/key@2x.webp'

  // Import preview images
  import ganttChartSource from '../../../javascript/images/modules/translations/index/gantt-chart.source.webp'
  import ganttChartSource2x from '../../../javascript/images/modules/translations/index/gantt-chart.source@2x.webp'
  import ganttChartTarget from '../../../javascript/images/modules/translations/index/gantt-chart.target.webp'
  import ganttChartTarget2x from '../../../javascript/images/modules/translations/index/gantt-chart.target@2x.webp'

  import invoiceSource from '../../../javascript/images/modules/translations/index/invoice.source.webp'
  import invoiceSource2x from '../../../javascript/images/modules/translations/index/invoice.source@2x.webp'
  import invoiceTarget from '../../../javascript/images/modules/translations/index/invoice.target.webp'
  import invoiceTarget2x from '../../../javascript/images/modules/translations/index/invoice.target@2x.webp'

  import posterSource from '../../../javascript/images/modules/translations/index/poster.source.webp'
  import posterSource2x from '../../../javascript/images/modules/translations/index/poster.source@2x.webp'
  import posterTarget from '../../../javascript/images/modules/translations/index/poster.target.webp'
  import posterTarget2x from '../../../javascript/images/modules/translations/index/poster.target@2x.webp'

  import resumeSource from '../../../javascript/images/modules/translations/index/resume.source.webp'
  import resumeSource2x from '../../../javascript/images/modules/translations/index/resume.source@2x.webp'
  import resumeTarget from '../../../javascript/images/modules/translations/index/resume.target.webp'
  import resumeTarget2x from '../../../javascript/images/modules/translations/index/resume.target@2x.webp'

  import slideSource from '../../../javascript/images/modules/translations/index/slide.source.webp'
  import slideSource2x from '../../../javascript/images/modules/translations/index/slide.source@2x.webp'
  import slideTarget from '../../../javascript/images/modules/translations/index/slide.target.webp'
  import slideTarget2x from '../../../javascript/images/modules/translations/index/slide.target@2x.webp'

  let { RailsApp, landing_page } = $props()

  const i18n = new I18n(i18n_translations)
  i18n.locale = RailsApp.I18n.locale

  const fileTypeIcons = {
    docx: { src: docxIcon, srcset: `${docxIcon} 1x, ${docxIcon2x} 2x` },
    xlsx: { src: xlsxIcon, srcset: `${xlsxIcon} 1x, ${xlsxIcon2x} 2x` },
    pptx: { src: pptxIcon, srcset: `${pptxIcon} 1x, ${pptxIcon2x} 2x` },
    key: { src: keyIcon, srcset: `${keyIcon} 1x, ${keyIcon2x} 2x` }
  }

  const allPreviews = [
    {
      key: 'gantt-chart',
      type: 'xlsx',
      source: { src: ganttChartSource, srcset: `${ganttChartSource} 1x, ${ganttChartSource2x} 2x` },
      target: { src: ganttChartTarget, srcset: `${ganttChartTarget} 1x, ${ganttChartTarget2x} 2x` }
    },
    {
      key: 'invoice',
      type: 'xlsx',
      source: { src: invoiceSource, srcset: `${invoiceSource} 1x, ${invoiceSource2x} 2x` },
      target: { src: invoiceTarget, srcset: `${invoiceTarget} 1x, ${invoiceTarget2x} 2x` }
    },
    {
      key: 'resume',
      type: 'docx',
      source: { src: resumeSource, srcset: `${resumeSource} 1x, ${resumeSource2x} 2x` },
      target: { src: resumeTarget, srcset: `${resumeTarget} 1x, ${resumeTarget2x} 2x` }
    },
    {
      key: 'poster',
      type: 'pptx',
      source: { src: posterSource, srcset: `${posterSource} 1x, ${posterSource2x} 2x` },
      target: { src: posterTarget, srcset: `${posterTarget} 1x, ${posterTarget2x} 2x` }
    },
    {
      key: 'slide',
      type: 'pptx',
      source: { src: slideSource, srcset: `${slideSource} 1x, ${slideSource2x} 2x` },
      target: { src: slideTarget, srcset: `${slideTarget} 1x, ${slideTarget2x} 2x` }
    }
  ]

  // Filter previews based on landing_page using imported mapping
  const requestedType = LANDING_PAGE_TO_EXTENSION[landing_page]
  const previewType = requestedType === 'key' ? 'pptx' : requestedType
  const previews = landing_page !== 'home' && requestedType
    ? allPreviews
        .filter(p => p.type === previewType)
        .map(p => requestedType === 'key' ? { ...p, type: 'key' } : p)
    : allPreviews

  // State management - if only one preview, show it directly
  let selectedPreview = $state(previews.length === 1 ? previews[0] : null)
  let currentIndex = $derived(
    selectedPreview ? previews.findIndex(p => p.key === selectedPreview.key) : -1
  )
  let isFirst = $derived(currentIndex === 0)
  let isLast = $derived(currentIndex === previews.length - 1)

  // Touch/swipe state
  let touchStartX = 0
  let touchEndX = 0

  // Reference to the section for scrolling
  let sectionRef

  // Navigation handler
  function handleNavigate(direction) {
    if (direction === 'prev') {
      if (isFirst) {
        selectedPreview = null  // Back to overview
      } else {
        selectedPreview = previews[currentIndex - 1]
      }
    } else if (direction === 'next') {
      if (isLast) {
        selectedPreview = null  // Back to overview
      } else {
        selectedPreview = previews[currentIndex + 1]
      }
    }

    // Scroll to top of section when changing views
    if (sectionRef) {
      sectionRef.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }

  // Preview container click handler
  function handlePreviewClick(preview) {
    selectedPreview = preview

    // Scroll to top of section when opening detail view
    if (sectionRef) {
      sectionRef.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }

  // Preview container keyboard handler
  function handlePreviewKeyDown(event, preview) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault()
      handlePreviewClick(preview)
    }
  }

  // Keyboard navigation in detail view
  function handleDetailKeyboard(event) {
    if (selectedPreview === null || previews.length === 1) return

    if (event.key === 'ArrowLeft') {
      event.preventDefault()
      handleNavigate('prev')
    } else if (event.key === 'ArrowRight') {
      event.preventDefault()
      handleNavigate('next')
    } else if (event.key === 'Escape') {
      event.preventDefault()
      selectedPreview = null
    }
  }

  // Touch/swipe handlers
  function handleTouchStart(e) {
    if (previews.length === 1) return
    touchStartX = e.changedTouches[0].screenX
  }

  function handleTouchEnd(e) {
    if (previews.length === 1) return
    touchEndX = e.changedTouches[0].screenX
    const swipeDistance = touchEndX - touchStartX

    if (Math.abs(swipeDistance) > 50) {  // Minimum swipe distance
      if (swipeDistance > 0) {
        handleNavigate('prev')  // Swipe right = previous
      } else {
        handleNavigate('next')  // Swipe left = next
      }
    }
  }

  // Setup keyboard event listener
  $effect(() => {
    if (previews.length > 1) {
      window.addEventListener('keydown', handleDetailKeyboard)
      return () => window.removeEventListener('keydown', handleDetailKeyboard)
    }
  })
</script>

<section id="formatting-and-layout" class="text-center pt-5 pb-5" bind:this={sectionRef}>
  <div class="container">
    {#if selectedPreview === null}
      <div class="main-view">
        <h2 class="text-black fw-normal mb-4">
          {i18n.t('Translations.Index.sections.formating_and_layout.title')}
        </h2>
        <div class="description mb-5 m-auto">
          {@html i18n.t('Translations.Index.sections.formating_and_layout.description')}
        </div>

        <div class="previews mx-auto d-flex flex-wrap row-gap-3 justify-content-center align-items-end mt-4">
          {#each previews as preview}
            <div
              aria-label="{i18n.t('Translations.Index.sections.formating_and_layout.previews.aria_label', {key: i18n.t(`Translations.Index.sections.formating_and_layout.previews.${preview.key}`)})}"
              class="preview-container d-flex flex-column align-items-center rounded-sm p-2"
              role="button"
              tabindex="0"
              onclick={() => handlePreviewClick(preview)}
              onkeydown={(e) => handlePreviewKeyDown(e, preview)}
            >
              <div class="d-flex gap-1 align-items-end mb-3">
                <img
                  class="preview-image border shadow-sm"
                  src="{preview.source.src}"
                  srcset="{preview.source.srcset}"
                  alt="{i18n.t(`Translations.Index.sections.formating_and_layout.previews.${preview.key}`)} - Before"
                />
                <img
                  class="preview-image border shadow-sm"
                  src="{preview.target.src}"
                  srcset="{preview.target.srcset}"
                  alt="{i18n.t(`Translations.Index.sections.formating_and_layout.previews.${preview.key}`)} - After"
                />
              </div>
              <div class="d-flex align-items-center gap-1 text-muted small">
                <img
                  class="file-type-icon"
                  src="{fileTypeIcons[preview.type].src}"
                  srcset="{fileTypeIcons[preview.type].srcset}"
                  alt="{preview.type}"
                />
                <span class="text-nowrap">
                  {i18n.t(`Translations.Index.sections.formating_and_layout.previews.${preview.key}`)}
                </span>
              </div>
            </div>
          {/each}
        </div>
      </div>
    {:else}
      <div class="detail-view">
        <h2 class="text-black fw-normal mb-5 text-center">
          {i18n.t('Translations.Index.sections.formating_and_layout.title')}
        </h2>

        <div
          class="detail-content-wrapper d-flex flex-column align-items-center justify-content-center position-relative"
          ontouchstart={handleTouchStart}
          ontouchend={handleTouchEnd}
        >
          <!-- Left navigation arrow -->
        {#if previews.length > 1}
        <button
          class="nav-arrow position-absolute top-50 translate-middle-y start-0 ms-4 ms-md-5 bg-white border rounded-circle shadow d-flex align-items-center justify-content-center"
          onclick={() => handleNavigate('prev')}
          aria-label={i18n.t('Translations.Index.sections.formating_and_layout.detail.previous_aria')}
        >
          <i class="bi bi-chevron-left fs-4"></i>
        </button>
        {/if}

        <!-- Center content: large images -->
        <div class="detail-content">
          <div class="detail-images-container d-flex gap-4 gap-md-5 align-items-end mb-4">
            <div class="detail-image-wrapper">
              <img
                class="detail-image border rounded shadow"
                src="{selectedPreview.source.srcset.split(' ')[2]}"
                alt="{i18n.t(`Translations.Index.sections.formating_and_layout.previews.${selectedPreview.key}`)} - Before"
              />
              <div class="text-center mt-3 text-muted small fw-medium">
                {i18n.t('Translations.Index.sections.formating_and_layout.detail.before')}
              </div>
            </div>

            <div class="detail-image-wrapper">
              <img
                class="detail-image border rounded shadow"
                src="{selectedPreview.target.srcset.split(' ')[2]}"
                alt="{i18n.t(`Translations.Index.sections.formating_and_layout.previews.${selectedPreview.key}`)} - After"
              />
              <div class="text-center mt-3 text-muted small fw-medium">
                {i18n.t('Translations.Index.sections.formating_and_layout.detail.after')}
              </div>
            </div>
          </div>

          <!-- File type label -->
          <div class="d-flex align-items-center gap-2 justify-content-center text-dark">
            <img
              class="file-type-icon-large"
              src="{fileTypeIcons[selectedPreview.type].src}"
              srcset="{fileTypeIcons[selectedPreview.type].srcset}"
              alt="{selectedPreview.type}"
            />
            <span class="text-nowrap fw-medium">
              {i18n.t(`Translations.Index.sections.formating_and_layout.previews.${selectedPreview.key}`)}
            </span>
          </div>
        </div>

        <!-- Right navigation arrow -->
        {#if previews.length > 1}
        <button
          class="nav-arrow position-absolute top-50 translate-middle-y end-0 me-4 me-md-5 bg-white border rounded-circle shadow d-flex align-items-center justify-content-center"
          onclick={() => handleNavigate('next')}
          aria-label={i18n.t('Translations.Index.sections.formating_and_layout.detail.next_aria')}
        >
          <i class="bi bi-chevron-right fs-4"></i>
        </button>
        {/if}
        </div>
      </div>
    {/if}
  </div>
</section>
